module.exports = __webpack_public_path__ + "IcoReportCom512.png";